/**
 * Полный URL сайта для canonical, OG и sitemap (без слэша в конце).
 * В продакшене задайте в .env: REACT_APP_SITE_URL=https://ваш-домен.com
 */
export function getSiteOrigin() {
  const fromEnv = process.env.REACT_APP_SITE_URL;
  if (fromEnv && typeof fromEnv === "string") {
    return fromEnv.replace(/\/$/, "");
  }
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "https://broxegroup.com";
}
export function getOgImagePath() {
  const raw = process.env.REACT_APP_OG_IMAGE_PATH || "/logo/big-logo.png";
  const path = typeof raw === "string" ? raw.trim() : "/logo/big-logo.png";
  return path.startsWith("/") ? path : `/${path}`;
}

export function getOgImageDimensions() {
  const w = process.env.REACT_APP_OG_IMAGE_WIDTH;
  const h = process.env.REACT_APP_OG_IMAGE_HEIGHT;
  if (w && h && !Number.isNaN(Number(w)) && !Number.isNaN(Number(h))) {
    return { width: Number(w), height: Number(h) };
  }
  return { width: 3000, height: 3000 };
}
